import { useEffect, useRef } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
